module.exports = __webpack_public_path__ + "static/img/bird.ee5ef747.png";